import React, { Component } from "react";
import { Modal, Header, Button } from "semantic-ui-react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import NestStore from "../../stores/NestStore";

/**
 * To use with any NestStore object. it will listen for errorMessage and disclose it.
 */
@observer
class ModalError extends Component {
  render() {
    const { nestStore } = this.props;
    return (
      <>
        <Modal open={!!nestStore.errorMessage}>
          <Header icon="exclamation circle" content="Oups" />
          <Modal.Content>
            <p>{nestStore.errorMessage}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="green"
              inverted
              onClick={() => {
                nestStore.errorMessage = "";
              }}
            >
              OK
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}
ModalError.propTypes = {
  nestStore: PropTypes.instanceOf(NestStore),
};
export default ModalError;
